<!--
  REV-21366 — activity log (Pure View). The root fills the height it is given, the header stays
  put and only the list scrolls; states go in place of the entries, precedence
  loading > error > empty > filled.
-->
<div class="alog" data-testid="activity-log">
    <div class="alog-header" data-testid="activity-log-header">
        <span class="ham-icon alog-header__icon" aria-hidden="true"><i class="clock-icon"></i></span>
        <span class="alog-header__text">
            <!-- The number is printed, `count` only picks singular or plural. -->
            {{ totalCount }} {{ 'abcp_activity_count' | i18next: { count: totalCount } }}
            <ng-container *ngIf="accountLabel">· {{ accountLabel }}</ng-container>
        </span>
    </div>

    <div class="alog-list" data-testid="activity-log-list">
        <div class="alog-loading" data-testid="activity-loading" *ngIf="loading; else notLoading">
            <div class="alog-skeleton-row" *ngFor="let row of skeletonRows" aria-hidden="true">
                <div class="alog-skeleton alog-skeleton--dot"></div>
                <div class="alog-skeleton-lines">
                    <div class="alog-skeleton alog-skeleton--meta"></div>
                    <div class="alog-skeleton alog-skeleton--title"></div>
                    <div class="alog-skeleton"></div>
                </div>
            </div>
        </div>

        <ng-template #notLoading>
            <div class="alog-error" data-testid="activity-error" *ngIf="error; else notError">
                {{ 'abcp_activity_error' | i18next }}
            </div>

            <ng-template #notError>
                <div class="alog-empty" data-testid="activity-empty" *ngIf="isEmpty; else filled">
                    {{ (plannedOnly ? 'abcp_activity_planned' : 'abcp_activity_empty') | i18next }}
                </div>

                <ng-template #filled>
                    <!-- Own wrapper so :first-child / :last-child keep drawing the timeline
                         correctly once the load-more button follows the entries. -->
                    <div class="alog-entries">
                        <div
                            class="alog-entry"
                            data-testid="activity-entry"
                            *ngFor="let entry of entries; trackBy: trackById"
                            [attr.data-actor-type]="entry.actor.type"
                            [attr.data-kind]="entry.kind"
                        >
                            <span class="ham-icon alog-entry__icon" aria-hidden="true">
                                <i [ngClass]="actorIconClass(entry)"></i>
                            </span>

                            <div class="alog-entry__body">
                                <div class="alog-entry__meta">
                                    <span class="alog-entry__actor" data-testid="activity-actor">
                                        {{ entry.actor.name || ('abcp_activity_actor_unknown' | i18next) }}
                                    </span>
                                    <span class="alog-entry__time" data-testid="activity-time">
                                        {{ entry.timeLabel }}
                                    </span>
                                </div>

                                <div class="alog-entry__title" data-testid="activity-title">{{ entry.title }}</div>

                                <div
                                    class="alog-entry__description"
                                    data-testid="activity-description"
                                    *ngIf="entry.description"
                                >
                                    {{ entry.description }}
                                </div>

                                <div class="alog-entry__raw" data-testid="activity-raw" *ngIf="entry.rawDetail">
                                    {{ entry.rawDetail }}
                                </div>

                                <!-- REV-21869 (#165) — a derivation: an amount plus its address. B2-8
                                     never sends one without the other, so both testids are gated on
                                     `amountLabel` alone. -->
                                <div class="alog-entry__derivation" *ngIf="entry.amountLabel != null">
                                    <span data-testid="activity-amount">{{ entry.amountLabel }}</span>
                                    <span data-testid="activity-derivation" [attr.data-derivation-id]="entry.derivationId"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- The testid sits on ham-button; the native <button> inside carries `disabled`. -->
                    <ham-button
                        class="alog-more"
                        data-testid="activity-load-more"
                        *ngIf="canLoadMore"
                        variant="white"
                        outline
                        size="sm"
                        icon="/assets/hamIcons/rotate-90-outline.svg"
                        [disabled]="loadingMore"
                        [attr.aria-disabled]="loadingMore"
                        [attr.aria-busy]="loadingMore"
                        (buttonClick)="onLoadMoreClick()"
                    >
                        {{ 'abcp_activity_load_more' | i18next }}
                    </ham-button>
                </ng-template>
            </ng-template>
        </ng-template>
    </div>
</div>
